import vueI18n from "@/i18n.ts";

class TextDot {
  maxLine: number = 3;
  allText: string = "";
  el;

  constructor(el, param) {
    this.el = el;
    param ? this.parseOpt(param) : null;
  }

  parseOpt(param) {
    this.maxLine = param.maxLine || 3;
  }

  wEl(style: string): number {
    return parseInt(window.getComputedStyle(this.el)[style]);
  }

  checkHeight() {
    return this.wEl("height") > this.wEl("lineHeight") * (0.5 + this.maxLine);
  }

  isMaxHeight(): boolean {
    return this.wEl("height") < this.wEl("lineHeight") * (0.5 + this.maxLine);
  }

  addBtn() {
    this.allText = this.el.innerText;
    this.el.classList.add("dot-text");
    this.el.innerText = "";
    this.el.style.maxHeight = `${this.wEl("lineHeight") *
      1.5 *
      this.maxLine}px`;

    let i = 0;
    while (this.isMaxHeight() && i < 500) {
      this.el.innerText = this.allText.slice(0, i);
      i++;
    }

    this.el.innerHTML = `${this.el.innerText.slice(0, -3)}...`;

    let btn = document.createElement("button");
    btn.classList.add("btn-flat", "secondary", "arrow-icon");
    btn.innerHTML = `${vueI18n.t("X13")}`;
    btn.addEventListener("click", () => {
      this.el.innerText = this.allText;
      this.el.classList.add("open");
      this.el.style.maxHeight = null;
    });
    this.el.append(btn);
  }
}

export default {
  bind: (el, { value }) => {},
  inserted: (el, { value }) => {
    const td = new TextDot(el, value);
    td.checkHeight() ? td.addBtn() : null;
  }
};
